import React, { useState, useEffect } from "react";
//Styles
import "../../../../assets/css/form.css";
//Cookie token
import cookie from "react-cookies";
//Router
import { useHistory, useParams } from "react-router-dom";
//GraphQL
import { useLazyQuery, gql } from "@apollo/client";
//Redux
import { useDispatch, useSelector } from "react-redux";
import {
  loadFormSettings,
  loadFormValue,
} from "../../../../actions/formDataActions";
//Components
import Form from "../../../formSections/Form";

const CountriesUpdate = () => {
  //Redirect if not logged in
  let history = useHistory();
  const token = cookie.load("usertk");
  let { id } = useParams();

  //Store data
  const { settings } = useSelector((state) => state.dataForm);

  //States
  const [displayForm, setDisplayForm] = useState(false);

  //API
  const GET_COUNTRY_2UPDATE = gql`
    query getCountry {
      getCountry(id: ${id}) {
        id
        name
      }
    }
  `;

  const [getCountry, { error, data }] = useLazyQuery(GET_COUNTRY_2UPDATE);

  //Redux actions
  const dispatch = useDispatch();
  const storeLoadFormValue = (valuePair) => dispatch(loadFormValue(valuePair));
  const storeLoadSettings = (defaultSettings) => dispatch(loadFormSettings(defaultSettings));

  //useEffect
  useEffect(() => {
    if (settings && settings !== {}) {
      setDisplayForm(true);
    } else {
      setDisplayForm(false);
    }
    // eslint-disable-next-line
  }, [settings]);

  useEffect(() => {
    if (data && !error) {
      //Section Settings
      const defaultSettings = {
        entity: "country",
        queryName: "updateCountry",
        title: "Editar País",
        text: "Por favor, modifique el nombre del país y después pulse en aceptar para que los cambios se guarden.",
        formContent: [
          {
            type: "fieldText",
            name: "name",
            size: 75,
            label: "Nombre del país",
            placeholder: "Nombre del nuevo país",
            required: true,
            validated: true,
            validation: "notEmpty",
            defaultValue: data.getCountry.name,
          },
          {
            type: "buttons",
            buttons: [
              {
                text: "Actualizar",
                action: "update",
                classes: "safe",
                actionType: "update",
                entity: "country",
                id: id,
              },
              {
                text: "Cancelar",
                action: "link",
                link: "/paises",
                classes: "unsafe",
                entity: "country",
              },
            ],
          },
        ],
      };
      storeLoadSettings(defaultSettings);
    }

    // eslint-disable-next-line
  }, [data, error]);

  useEffect(() => {
    getCountry();
    //Load id value to store
    storeLoadFormValue(["id", id]);
    // eslint-disable-next-line
  }, []);

  return (
    <>
      {!token ? (
        history.push("/")
      ) : (
        <>
          <div className="table-container">{displayForm && <Form />}</div>
        </>
      )}
    </>
  );
};

export default CountriesUpdate;
